// extracted by mini-css-extract-plugin
module.exports = {"versionPicker":"VersionPicker_versionPicker__hoPBe","menu":"VersionPicker_menu__1wJVD","smallDevice":"VersionPicker_smallDevice__1rW7l"};